import { useEffect } from "react";

/**
 * SEO component - updates document title, meta description, canonical
 * React 19 native metadata support via document manipulation
 */
export default function SEO({ title, description, canonical, ogImage }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, useProperty = false) => {
      if (!content) return;
      const attr = useProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) setMeta("description", description);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", "website", true);
    if (ogImage) setMeta("og:image", ogImage, true);
    if (canonical) setMeta("og:url", canonical, true);

    // Canonical link
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical, ogImage]);

  return null;
}
